module.exports = __webpack_public_path__ + "static/media/image03.cdb2d9ea.jpg";